module.exports = __webpack_public_path__ + "static/our-mission-2acc4924b706f02c98c598dd15518841.svg";